module.exports = __webpack_public_path__ + "50529806.png";